import React from 'react';

function Footer() {
return(

<footer className="fixed-bottom">


</footer>
    );
}

export default Footer;